import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

//import 'ol/ol.css';
//import { ol } from 'ol';
import { Feature, Map, Overlay, View } from 'ol';
import { Layer, Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { Fill, Stroke, Style, Text } from 'ol/style';
import { fromLonLat, toLonLat, transform } from 'ol/proj';
import { defaults as defaultControls, ZoomToExtent } from 'ol/control';
import { extend, createEmpty } from 'ol/extent';

//import Map from 'ol/Map';
//import View from 'ol/View';
//import VectorLayer from 'ol/layer/Layer';
import VectorSource from 'ol/source/Vector';
//import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import ImageTile from 'ol/ImageTile';

//import { Feature, geom, layer, Map, source, View } from 'ol';
//import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
//import { add } from 'ol/coordinate';
//import source from 'ol/source';
//import Tile from 'ol/layer';
//import OSM from 'ol/source/OSM';
//import fromLonLat from 'ol/proj';
//import ZoomToExtent from 'ol/control/ZoomToExtent';

//import { MapType } from '@angular/compiler/src/output/output_ast';
import { AzureMapsService } from '../../services/azure-maps.service';
import { OrderService } from '../../services/order.service';
//import {
//    MapModule, MapAPILoader, MarkerTypeId, IMapOptions, IBox, IMarkerIconInfo, WindowRef,
//    DocumentRef, MapServiceFactory,
//    BingMapAPILoaderConfig, BingMapAPILoader,
//    GoogleMapAPILoader, GoogleMapAPILoaderConfig, ILatLong, Polyline, IPolylineOptions, Layer
//} from 'angular-maps';
//import {
//    MapModule, MapAPILoader, MarkerTypeId, IMapOptions, IBox, IMarkerIconInfo, WindowRef,
//    DocumentRef, MapServiceFactory,
//    BingMapAPILoaderConfig, BingMapAPILoader,
//    GoogleMapAPILoader, GoogleMapAPILoaderConfig, ILatLong, Polyline, IPolylineOptions
//} from 'angular-maps';

import { GeoCoordinate, OrderStopLatLon, SearchCheckCallLatLon } from '../../models/models';
import TileSource from 'ol/source/Tile';

@Component({
    selector: 'openlayers-map',
    templateUrl: './openlayers-map.component.html',
    standalone: false
})

export class OpenLayersMap implements AfterViewInit, OnChanges, OnInit {
    @Input() orderStops: OrderStopLatLon[] = [];
    @Input() checkCalls: SearchCheckCallLatLon[] = [];
    //@Input() mileMarkers: CheckCall[] = [];
    @Input() quoteOrderID: number = 0;
    @Input() orderNumber: string = "";
    @Input() quoteOrderLineID: number = 0;
    @Output() onGetCoordinate = new EventEmitter<any>();

    // Map variables
    //public _markerTypeId = MarkerTypeId;
    //public map: Map;
    public baseLayer: TileLayer<TileSource> = new TileLayer({
        source: new XYZ({
            url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            attributions: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            attributionsCollapsible: false,
            tileLoadFunction: (imageTile, src) => {
                const image = (imageTile as ImageTile).getImage() as HTMLImageElement;
                image.referrerPolicy = 'strict-origin-when-cross-origin';
                image.src = src;
            }
        })
    });
    public map: Map = new Map({
        target: 'map',
        layers: [this.baseLayer],
        view: new View({
            //center: [0, 0],
            center: fromLonLat([-98.6, 39.825]),
            zoom: 4
        })//,
        //controls: defaultControls().extend([
        //    new ZoomToExtent({
        //        extent: [
        //        ]
        //    })
        //])
    });

    //public _options: IMapOptions = {
    //    disableBirdseye: false,
    //    disableStreetside: true,
    //    navigationBarMode: 1,
    //    zoom: 5,
    //    mapTypeId: 7,
    //    disableZooming: false
    //};
    //public _box: IBox = {
    //    maxLatitude: 45,
    //    maxLongitude: -80,
    //    minLatitude: 0,
    //    minLongitude: -100,
    //    padding: 1
    //};
    //public _iconInfo: IMarkerIconInfo = {
    //    markerType: MarkerTypeId.FontMarker,
    //    fontName: 'FontAwesome',
    //    fontSize: 48,
    //    color: 'red',
    //    markerOffsetRatio: { x: 0.5, y: 1 },
    //    text: '\uF276'
    //};
    //public stopMarkers: Array<ILatLong> = new Array<ILatLong>();
    //public checkCallMarkers: Array<ILatLong> = new Array<ILatLong>();
    //public truckRoute: Array<ILatLong> = new Array<ILatLong>();
    //public polylines: Array<IPolylineOptions> = new Array<IPolylineOptions>();

    constructor(private azureMapsService: AzureMapsService, private orderService: OrderService) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.initMap();
        //this.addMapLocation(-98.6, 39.825);
        //setTimeout(() => {
        //    this.map.updateSize();
        //}, 500);
        setTimeout(() => {
            this.map.updateSize();
        }, 500);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.removeAllLayers();

        if (this.quoteOrderID > 0
            || this.quoteOrderLineID > 0
            || changes.orderStops != null && (changes.orderStops.currentValue as OrderStopLatLon[]).length > 0
            || changes.checkCalls != null && (changes.checkCalls.currentValue as SearchCheckCallLatLon[]).length > 0) {
            this.getStops();
            this.getCheckCalls();
        }
        //console.log("openlayers-map:ngOnChanges", this.quoteOrderID, this.quoteOrderLineID, this.orderStops);

        //if (changes.orderStops != null && (changes.orderStops.currentValue as OrderStop[]).length > 0) {
        //    this.setStopMarkers();
        //    //console.log("ngOnChanges:orderStops", this.quoteOrderID, this.quoteOrderLineID, this.orderStops);
        //}
        //if (changes.checkCalls != null && (changes.checkCalls.currentValue as SearchCheckCall[]).length > 0) {
        //    this.setCheckCallMarkers();
        //    this.setMileMarkerMarkers();
        //    //console.log("ngOnChanges:checkCalls", this.quoteOrderID, this.quoteOrderLineID, this.checkCalls);
        //}

        setTimeout(() => {
            this.map.updateSize();
        }, 500);
    }

    public getCoordinate(evt: any) {
        var coordinate = this.map.getEventCoordinate(evt);
        var lonLat = transform(coordinate, 'EPSG:3857', 'EPSG:4326');
        //var lonLat = transform(coordinate, 'EPSG:4326', 'EPSG:3857');
        var longitude = lonLat[0];
        var latitude = lonLat[1];
        this.removeMapLayer("single");
        this.addMapLocation("single", "current", latitude, longitude, 10);
        this.setCenter(latitude, longitude);
        this.onGetCoordinate.emit(lonLat);
        console.log("getCoordinate", longitude, latitude);
    }

    public addSingleLatLon(latitude: number, longitude: number) {
        this.removeMapLayer("single");
        this.addMapLocation("single", "current", latitude, longitude, 10);
        this.setCenter(latitude, longitude);
        this.map.getView().setZoom(12);
    }

    public setCenter(latitude: number, longitude: number) {
        this.map.getView().setCenter(fromLonLat([longitude, latitude]));
    }

    private getStops() {
        if (this.orderStops.length > 0) {
            this.setStopMarkers();
        }
        else {
            if (this.quoteOrderID > 0) {
                this.orderService.getStopsLatLonByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                    this.orderStops = result.resultCollection;
                    if (this.orderStops.length > 0) {
                        this.setStopMarkers();
                    }
                    //console.log("openlayers-map:ngOnInit:quoteOrderID", this.quoteOrderID, this.quoteOrderLineID, this.orderStops);
                });
            }
            else if (this.orderNumber != "") {
                //this.orderService.getStopsLatLonByOrderNumber(this.orderNumber).subscribe(result => {
                //    this.orderStops = result.resultCollection;
                //    if (this.orderStops.length > 0) {
                //        this.setStopMarkers();
                //    }
                //});
            }
            else if (this.quoteOrderLineID > 0) {
                this.orderService.getStopsLatLonByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
                    this.orderStops = result.resultCollection;
                    if (this.orderStops.length > 0) {
                        this.setStopMarkers();
                    }
                    //console.log("openlayers-map:ngOnInit:quoteOrderLineID", this.quoteOrderID, this.quoteOrderLineID, this.orderStops);
                });
            }
        }
    }

    private getCheckCalls() {
        if (this.checkCalls.length > 0) {
            this.setCheckCallMarkers();
            this.setMileMarkerMarkers();
        }
        else {
            if (this.quoteOrderID > 0) {
                this.orderService.getSearchCheckCallLatLonByQuoteOrderID(this.quoteOrderID, "").subscribe(result => {
                    this.checkCalls = result.resultCollection;
                    if (this.checkCalls.length > 0) {
                        this.setCheckCallMarkers();
                        this.setMileMarkerMarkers();
                    }
                    //console.log("openlayers-map:ngOnInit:quoteOrderID", this.quoteOrderID, this.quoteOrderLineID, this.checkCalls);
                });
            }
            else if (this.orderNumber != "") {
                this.orderService.getSearchCheckCallLatLonByQuoteOrderID(this.quoteOrderID, "").subscribe(result => {
                    this.checkCalls = result.resultCollection;
                    if (this.checkCalls.length > 0) {
                        this.setCheckCallMarkers();
                        this.setMileMarkerMarkers();
                    }
                });
            }
            else if (this.quoteOrderLineID > 0) {
                this.orderService.getSearchCheckCallLatLonByQuoteOrderLineID(this.quoteOrderLineID, "").subscribe(result => {
                    this.checkCalls = result.resultCollection;
                    if (this.checkCalls.length > 0) {
                        this.setCheckCallMarkers();
                        this.setMileMarkerMarkers();
                    }
                    //console.log("openlayers-map:ngOnInit:quoteOrderLineID", this.quoteOrderID, this.quoteOrderLineID, this.checkCalls);
                });
            }
        }
    }

    // Map methods
    initMap() {
        //this.map = new Map({ target: 'map' });
        //this.map.setView(new View({
        //    center: [0, 0],
        //    zoom: 2
        //}));
        //var osmSource = OSM();
        //var osmLayer = new Tile.TileLayer({ source: osmSource });
        //this.map.addLayer(osmLayer);

        this.baseLayer = new TileLayer({
            source: new XYZ({
                url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                attributions: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                attributionsCollapsible: false,
                tileLoadFunction: (imageTile, src) => {
                    const image = (imageTile as ImageTile).getImage() as HTMLImageElement;
                    image.referrerPolicy = 'strict-origin-when-cross-origin';
                    image.src = src;
                }
            })
        });

        var view = new View({
            //center: [0, 0],
            center: fromLonLat([-98.6, 39.825]),
            zoom: 4
        });

        this.map = new Map({
            target: 'map',
            layers: [this.baseLayer],
            view: view//,
            //controls: defaultControls().extend([
            //    new ZoomToExtent({
            //        extent: [
            //        ]
            //    })
            //])
        });

        //view.setCenter([-98.6, 39.825]);

        //this.map = new Map({
        //    target: 'map',
        //    layers: [
        //        new TileLayer({
        //            source: new XYZ({
        //                url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        //            })
        //        })
        //        //new Tile({
        //        //    source: OSM()
        //        //})
        //    ],
        //    view: new View({
        //        center: [0, 0],
        //        zoom: 2
        //    })
        //    //controls: defaultControls().extend([
        //    //    new ZoomToExtent({
        //    //        extent: [
        //    //        ]
        //    //    })
        //    //])
        //});
    }

    zoomToAllLayersExtent() {
        const allLayersExtent = createEmpty(); // Initialize an empty extent

        this.map.getLayers().forEach((layer) => {
            if (layer instanceof VectorLayer) {
                const source = (layer as Layer).getSource();
                if (source instanceof VectorSource) { // Check if it's a vector source
                    const layerExtent = source.getExtent();
                    if (layerExtent && layerExtent.every(coord => isFinite(coord))) { // Ensure valid extent
                        extend(allLayersExtent, layerExtent); // Extend the combined extent
                    }
                }
                // You might need to handle other layer types if their extent is relevant
            }
        });

        if (!allLayersExtent.every(coord => coord === Infinity || coord === -Infinity)) { // Check if extent is not empty
            this.map.getView().fit(allLayersExtent, {
                size: this.map.getSize(),
                padding: [50, 50, 50, 50], // Optional: add padding
                duration: 1000, // Optional: animation duration
            });
        }
        //console.log("zoomToAllLayersExtent");
    }


    setMapExtent() {
        const layers = [...this.map.getLayers().getArray()];
        //console.log(layers);
        var minX = 0;
        var minY = 0;
        var maxX = 0;
        var maxY = 0;
        for (var i = 0; i < layers.length; i++) {
            if (layers[i] && i > 0) {
                var layerExtent = layers[i].getExtent();
                if (layerExtent) {
                    if (layerExtent[0] <= (minX != 0 ? minX : layerExtent[0])) {
                        minX = layerExtent[0];
                    }
                    if (layerExtent[1] <= (minY != 0 ? minY : layerExtent[1])) {
                        minY = layerExtent[1];
                    }
                    if (layerExtent[2] >= (maxX != 0 ? maxX : layerExtent[2])) {
                        maxX = layerExtent[2];
                    }
                    if (layerExtent[3] >= (maxY != 0 ? maxY : layerExtent[3])) {
                        maxY = layerExtent[3];
                    }
                }
                //console.log("layer", minX, minY, maxX, maxY, layerExtent, layers[i]);
            }
        }
        //var extentFactor = 0.011;
        //console.log("setMapExtent", minX, minY, maxX, maxY, this.map.getSize());
        //var mapExtent = [minX - minX * extentFactor, minY - minY * extentFactor, maxX + maxX * extentFactor, maxY + maxY * extentFactor];
        var mapExtent = [minX, minY, maxX, maxY];
        //console.log("setMapExtent", mapExtent, this.map.getSize());
        //this.map.getView().fit(mapExtent, this.map.getSize());
        var zoom = this.map.getView().getZoom();
        if (zoom && zoom > 1) {
            this.map.getView().setZoom(zoom - 0.5);
        }
    }

    addMapLocation(name: string, text: string, lat: number, lon: number, zindex: number) {
        if (lat == 0 && lon == 0) {
            // Don't plot 0,0 coords
            return;
        }
        // icon code reference: https://github.com/google/material-design-icons/
        // map pin: place=e55f
        // truck: local_shipping=e558
        // phone: local_phone=e551
        // marker with check: beenhere=e52d
        // stop sign: report=e160
        // clock timer: access_time=e192
        // right arrow: arrow_forward=e5c8
        // check mark: check=e5ca
        // circle: stop_circle=ef71
        // play circle: play_circle_fill=e038
        var iconText = "";
        var markerColor = "";
        var labelColor = "";
        var markerFont = "normal 30px 'Material Icons'";
        var textFont = "bold 23px Arial";
        var labelFontBGText = "";

        if (name == "Check Call") {
            //iconText = "\ue52d";
            //color = "green";
            iconText = "\ue558";
            labelColor = "red";
            markerColor = "red";
        }
        else if (name == "Mile Marker") {
            //iconText = "\ue160";
            //color = "red";
            iconText = "\ue52d";
            labelColor = "blue";
            markerColor = "blue";
        }
        else if (name == "Stop") {
            if (text == "current") {
                textFont = "normal 26px 'Material Icons'";
                //text = "\ue192";
                text = "\ue192";
                labelFontBGText = "\uef71";
                iconText = "\ue55f";
                labelColor = "white";
                markerColor = "orange";
            }
            else {
                iconText = "\ue55f";
                labelColor = "green";
                markerColor = "green";
            }
        }
        else {
            iconText = "\ue55f";
            labelColor = "red";
            markerColor = "red";
        }

        var iconFeature = this.getIconFeature(name, lat, lon);

        //var iconStyleWD = new Style({
        //    text: new Text({
        //        text: '\uf053',
        //        font: 'normal 36px Wingdings',
        //        textBaseline: 'top',
        //        rotation: 3.14159,
        //        fill: new Fill({
        //            color: color
        //        }),
        //    })
        //});

        //var iconStyleFA = new Style({
        //    text: new Text({
        //        text: '\uf041',
        //        font: 'normal 36px \'Font Awesome 5 Free\'',
        //        textBaseline: 'bottom',
        //        fill: new Fill({
        //            color: color
        //        }),
        //    })
        //});

        var textAlign = "center";

        if (name == "Stop") {
            var iconStyle = [
                new Style({
                    text: new Text({
                        text: iconText,
                        font: markerFont,
                        textAlign: 'center',
                        textBaseline: 'middle',
                        fill: new Fill({
                            color: markerColor
                        }),
                    })
                }),
                new Style({
                    text: new Text({
                        text: labelFontBGText,
                        font: 'normal 28px \'Material Icons\'',
                        offsetY: -24,
                        textAlign: textAlign,
                        textBaseline: 'middle',
                        fill: new Fill({
                            color: "orange"
                        }),
                    })
                }),
                new Style({
                    text: new Text({
                        text: text,
                        font: textFont,
                        offsetY: -24,
                        textAlign: textAlign,
                        textBaseline: 'middle',
                        fill: new Fill({
                            color: labelColor
                        }),
                    })
                })
            ];
            iconFeature.setStyle(iconStyle);
        }
        else {
            var iconStyleMI = new Style({
                text: new Text({
                    text: iconText,
                    font: markerFont,
                    textAlign: 'center',
                    textBaseline: 'middle',
                    fill: new Fill({
                        color: markerColor
                    }),
                })
            });
            iconFeature.setStyle(iconStyleMI);
        }

        var source = new VectorSource({
            features: [iconFeature]
        });

        var layer = new VectorLayer({
            //name: name,
            source: source
        });
        layer.setProperties({ name: name });
        layer.setZIndex(zindex);

        this.map.addLayer(layer);
    }

    getIconFeature(name: string, lat: number, lon: number) {
        var feature = new Feature({
            name: name,
            geometry: new Point(fromLonLat([lon, lat]))
        });
        return feature;
    }

    addMapLineString(points, name: string, color: string, size: number, zindex: number) {
        // Line feature object format:
        //var feat = {
        //    "type": "FeatureCollection",
        //    "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },

        //    "features": [
        //        { "type": "Feature", "properties": { "name": "Roussel" }, "geometry": { "type": "LineString", "coordinates": [[-74.317812426119204, 48.287712285170407], [-73.965445435101188, 48.287712285170407]] } },
        //        { "type": "Feature", "properties": { "name": "de la Grande-Décharge Sud" }, "geometry": { "type": "LineString", "coordinates": [[-72.890274359943689, 47.66777849648031], [-73.03935270229745, 47.552045722357249], [-73.03483517677158, 47.743778832463107], [-72.750231068641639, 47.749854072477497], [-72.754748594167509, 47.552045722357249]] } },
        //        { "type": "Feature", "properties": { "name": "du Saguenay Ouest" }, "geometry": { "type": "LineString", "coordinates": [[-73.007730023616347, 48.07082744644633], [-72.894791885469544, 47.889388912080449], [-72.727643441012276, 48.082900678850329], [-72.560494996555022, 47.895447137861773]] } },
        //        { "type": "Feature", "properties": { "name": "Saint-Anicet" }, "geometry": { "type": "LineString", "coordinates": [[-72.985142395986983, 48.338787334581873], [-72.980624870461128, 48.161307640513321], [-72.885756834417805, 48.164320903012829], [-72.894791885469544, 48.338787334581873]] } },
        //        { "type": "Feature", "properties": { "name": "Saint-Remy-en-Bouzemont-Saint-Genest-et-Isson" }, "geometry": { "type": "LineString", "coordinates": [[-73.459482576203527, 47.53679865861892], [-73.454965050677686, 47.719470781160837]] } },
        //        { "type": "Feature", "properties": { "name": "Sainte-Geneviève" }, "geometry": { "type": "LineString", "coordinates": [[-73.716981531178234, 47.889388912080449], [-73.423342371996569, 48.091953743979651], [-73.242641350961676, 47.883329977544491], [-73.685358852497131, 47.862118125007399]] } },
        //        { "type": "Feature", "properties": { "name": "de Lombard" }, "geometry": { "type": "LineString", "coordinates": [[-73.631148546186679, 48.323770568268507], [-73.626631020660795, 48.185408784389622], [-73.55435061224685, 48.188420630879783], [-73.55435061224685, 48.320766684325278], [-73.473035152781165, 48.317762623483489], [-73.482070203832905, 48.19745510840756], [-73.400754744367205, 48.206487993065075], [-73.396237218841335, 48.323770568268507], [-73.301369182798027, 48.317762623483489], [-73.319439284901506, 48.191432300378096]] } },
        //        { "type": "Feature", "properties": { "name": "de la Grande-Baie Sud" }, "geometry": { "type": "LineString", "coordinates": [[-74.439785615317746, 47.564240180362376], [-74.227461915601779, 47.716431476953346], [-74.055795945618627, 47.552045722357249], [-73.879612450109633, 47.710352336655504]] } },
        //        { "type": "Feature", "properties": { "name": "de Tadoussac" }, "geometry": { "type": "LineString", "coordinates": [[-74.313294900593348, 48.091953743979651], [-74.313294900593348, 47.880300244488787], [-73.974480486152942, 47.877270334238752], [-73.978998011678812, 48.076864416783366]] } }
        //    ]
        //}

        var lineString = new LineString(points);
        lineString.transform('EPSG:4326', 'EPSG:3857');

        var feature = new Feature({
            name: name,
            geometry: lineString
        });

        var lineStyle = new Style({
            stroke: new Stroke({
                color: color,
                width: size
            })
        });

        var source = new VectorSource({
            features: [feature]
        });

        var layer = new VectorLayer({
            //name: name,
            source: source,
            style: [lineStyle]
        });
        layer.setZIndex(zindex);

        //var layerExtent = layer.getSource().getExtent();

        this.map.addLayer(layer);

        //if (layerExtent) {
        //    this.map.getView().fit(layerExtent, this.map.getSize());
        //}
    }

    mapLineStyle() {
        var style = new Style({
            stroke: new Stroke({
                color: 'blue',
                width: 2
            })
            //, text: CreateTextStyle(feature, resolution, myDom.lines)
        });
        return style;
    }

    removeAllLayers() {
        this.orderStops = [];
        this.checkCalls = [];
        this.removeMapLayer("single");
        this.removeMapLayer("Stop");
        this.removeMapLayer("Check Call");
        this.removeMapLayer("Mile Marker");
    }

    removeMapLayer(name: string) {
        const layers = [...this.map.getLayers().getArray()];
        //console.log("openlayers-map:removeMapLayer", name, layers);
        layers.forEach(layer => {
            if (layer && layer.getProperties().name === name) {
                this.map.removeLayer(layer);
            }
        });
        //this.map.getLayers().forEach(layer => {
        //    if (layer && layer.get("name") === name) {
        //        this.map.removeLayer(layer);
        //    }
        //});
    }

    setStopMarkers() {
        var layerName = "Stop";
        //var lineColor = "blue";
        // blue with 50% transparency
        var lineColor = 'rgba(0, 0, 255, 0.5)';
        this.removeMapLayer(layerName);
        //var lineId = 0;
        var isCurrent = false;

        // Sort stops
        var orderStops = this.orderStops.sort((left, right): number => {
            if (left.seq < right.seq) return -1;
            if (left.seq > right.seq) return 1;
            return 0;
        });

        for (var i = 0; i < orderStops.length; i++) {
            //if (i == 0) {
            //    lineId = orderStops[i].quoteOrderLineId;
            //}
            if (i == 0 && orderStops[i].isArr != true && orderStops[i].isDep != true) {
                isCurrent = true;
            }
            else if (orderStops[i].isArr == true && orderStops[i].isDep != true) {
                isCurrent = true;
            }
            else if (orderStops[i].isArr != true && orderStops[i].isDep != true && orderStops[i - 1].isDep == true) {
                isCurrent = true;
            }
            else {
                isCurrent = false;
            }
            var label = "";
            if (isCurrent) {
                // Current stop
                label = "current";
            }
            else if (i == 0) {
                // First stop
                label = orderStops[i].seq.toString();
            }
            else if (i == orderStops.length - 1) {
                // Last stop
                label = orderStops[i].seq.toString();
            }
            var zIndex = 30;
            if (label == "current") {
                zIndex = 35;
            }
            //console.log("setStopMarkers", label, orderStops[i]);
            // orderStops[i].stopSequence.toString()
            this.addMapLocation(layerName, label, orderStops[i].lat, orderStops[i].lon, zIndex);
        }

        //this.orderStops.forEach((orderStop, index) => {
        //    lineId = orderStop.quoteOrderLineId;
        //    this.addMapLocation(layerName, orderStop.stopSequence.toString(), orderStop.latitude, orderStop.longitude, 30);
        //});

        //var cities = this.orderStops.filter(s => s.city != null).map(s => s.city).map(c => c.cityId);
        var cities = this.orderStops.map(c => c.cityID);

        //this.azureMapsService.getTruckRouteFromCityIds(cities).subscribe(result => {
        //    this.truckRoute = new Array<ILatLong>();
        //    result.forEach(gc => {
        //        this.truckRoute.push({ latitude: gc.latitude, longitude: gc.longitude });
        //    });
        //    this.hasRoute = true;
        //    this.polylines.push({
        //        id: 0,
        //        path: this.truckRoute,
        //        strokeWeight: 5,
        //        strokeColor: 'red'
        //    });
        //});

        var points = new Array();

        if (cities.length > 1) {
            //getTruckRouteFromCityIds
            this.azureMapsService.getTruckRouteFromCityIDList(cities).subscribe(result => {
                //this.truckRoute = new Array<ILatLong>();
                //var gcList: GeoCoordinate[] = [];
                //if (result != "") {
                //    gcList = JSON.parse(result);
                //}
                result.forEach(gc => {
                    //this.truckRoute.push({ latitude: gc.latitude, longitude: gc.longitude });
                    if (gc.Lon != null && gc.Lat != null) {
                        points.push([gc.Lon, gc.Lat]);
                    }
                });

                //var layerLines = new VectorLayer({
                //    source: new VectorSource({
                //        features: [new Feature({
                //            geometry: new LineString(points),
                //            name: "Truck Route"
                //        })]
                //    }),
                //    style: this.mapLineStyle()
                //});
                //this.map.addLayer(layerLines);

                if (points.length > 1) {
                    this.addMapLineString(points, layerName, lineColor, 3, 1);
                }

                //this.hasRoute = true;
                //this.polylines.push({
                //    id: 0,
                //    path: this.truckRoute,
                //    strokeWeight: 5,
                //    strokeColor: 'red'
                //});
            });

            //this.setMapExtent();
        }

        //this.setMapExtent();
        this.zoomToAllLayersExtent();
    }

    setCheckCallMarkers() {
        var layerName = "Check Call";
        this.removeMapLayer(layerName);

        this.checkCalls.forEach((checkCall, index) => {
            if (checkCall.code != "MM") {
                this.addMapLocation(layerName, "", checkCall.lat, checkCall.lon, 20);
            }
        });

        //var cities = this.checkCalls.filter(s => s.city != null).map(s => s.city).map(c => c.cityId);
        //var points = new Array();

        //if (cities.length > 1) {
        //    this.azureMapsService.getTruckRouteFromCityIds(cities).subscribe(result => {
        //        result.forEach(gc => {
        //            if (gc.longitude != null && gc.latitude != null) {
        //                points.push([gc.longitude, gc.latitude]);
        //            }
        //        });

        //        if (points.length > 1) {
        //            this.addMapLineString(points, layerName, "green", 2, 2);
        //        }
        //    });
        //}

        //this.setMapExtent();
        this.zoomToAllLayersExtent();
    }

    setMileMarkerMarkers() {
        var layerName = "Mile Marker";
        this.removeMapLayer(layerName);

        this.checkCalls.forEach((checkCall, index) => {
            if (checkCall.code == "MM") {
                this.addMapLocation(layerName, "", checkCall.lat, checkCall.lon, 10);
            }
        });
    }
}
